function dmsToDecimal(dms) {
  // Intentar extraer grados, minutos, segundos y dirección
  const regex =
    /(-?\d+(?:\.\d+)?)[°º]?\s*(\d+(?:\.\d+)?)?['´]?\s*(\d+(?:\.\d+)?)?["”]?\s*([NSEW])?/i;
  const match = dms.match(regex);

  if (!match) return null;

  const degrees = parseFloat(match[1]) || 0;
  const minutes = parseFloat(match[2]) || 0;
  const seconds = parseFloat(match[3]) || 0;
  const direction = (match[4] || "").toUpperCase();

  let decimal = Math.abs(degrees) + minutes / 60 + seconds / 3600;

  // Negar si es dirección Sur o Oeste, o si ya era negativa
  if (direction === "S" || direction === "W" || degrees < 0) {
    decimal *= -1;
  }

  return decimal;
}

function cleanDecimal(coord) {
  const match = coord.match(/-?\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : null;
}

function normalizarCoordenada(coord) {
    if (coord == null) return null;
  
    const coordStr = String(coord).trim();
    const isDMS = /[°º'´"]/i.test(coordStr);
    const value = isDMS ? dmsToDecimal(coordStr) : cleanDecimal(coordStr);
  
    return value != null ? parseFloat(value.toFixed(6)) : null;
  }
  

export default normalizarCoordenada;
